import { useEffect, useState } from "react";

type DeviceType = "Android" | "iPhone" | "Unknown";

export function useDeviceType(): DeviceType {
  const [deviceType, setDeviceType] = useState<DeviceType>("Unknown");

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor;

    if (/android/i.test(userAgent)) {
      setDeviceType("Android");
    } else if (/iPad|iPhone|iPod/.test(userAgent)) {
      setDeviceType("iPhone");
    } else {
      setDeviceType("Unknown");
    }
  }, []);

  return deviceType;
}
